<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { todoPanelStore } from "../stores";
  import { saveModalStatus } from "./utils";

  const onclick = async () => {
    $todoPanelStore.outcome = "notInterested";
    $todoPanelStore.status = "done";

    return saveModalStatus();
  };
</script>

<ButtonWithTooltip
  kind="secondary"
  leadingIcon="fa-regular fa-face-frown"
  class="flex-1"
  {onclick}
  size="large"
  placement="top"
>
  <span slot="tooltip"
    >Mark this contact as 'Not Interested'.<br />Campaign steps will stop</span
  >
  Not Interested
</ButtonWithTooltip>
